// all components from library, for example: ExploreImage, AvertOverlay..
export * from './components';

// all the container from library, for example: ExploreContainer
export * from './container';

import ZoneApi from './api/adserver';

export interface AnalyticsAPI {
  trackAdvertAction?: (
    action: string,
    advertName: string,
    advertCategory: string,
    id: string,
    advertCategoryId: string,
  ) => void;
  trackAdvertCategory?: (category: string, id: string) => void;
  trackAdvertView?: (
    id: string,
    name: string,
    categoryId: string,
    categoryName: string,
    advertiserId: string,
    advertiserName: string,
    campaignId: string,
    campaignName: string,
  ) => void;
  trackAdvertDetailView?: (
    id: string,
    name: string,
    categoryId: string,
    categoryName: string,
    advertiserId: string,
    advertiserName: string,
    campaignId: string,
    campaignName: string,
  ) => void;
  trackServiceDetailView?: (
    id: string,
    name: string,
    categoryId: string,
    categoryName: string,
    advertiserId: string,
    advertiserName: string,
    campaignId: string,
    campaignName: string,
    serviceName: string,
  ) => void;
  trackAdvertCategoryAction?: (
    category: string,
    categoryId: string,
    advertName: string,
    advertId: string,
    action: string,
  ) => void;
  trackScreenView?: (screenName: string) => void;
  trackSearch?: (screenName: string) => void;
  trackNewsDetailView?: (newsId: string, newsName: string) => void;
  trackGalleryView?: (galleryId: string, galleryTitle: string) => void;
  trackContestView?: (contestId: string, contestTitle: string) => void;
  trackEvent?: () => Promise<void>;
  trackScreen?: (screenName: any) => Promise<void>;
  trackProperty?: (unitid: any, userid: any, property: any) => Promise<void>;
}

interface ZoneHost {
  advertAgeApiDev: string;
  pmsApiDev: string;
  advertAgeApiProd: string;
  pmsApiProd: string;
  analytics: AnalyticsAPI;
}

interface ZoneTail {
  init: ({
    advertAgeApiDev,
    advertAgeApiProd,
    pmsApiDev,
    pmsApiProd,
    analytics,
  }: ZoneHost) => void;
}

const ZontailConfig: ZoneTail = {
  /**
   * init host to library
   * @param advertAgeApi host of avert and agegated server
   * @param developmentServerApi host of development server
   */
  init: function ({
    advertAgeApiDev,
    advertAgeApiProd,
    pmsApiDev,
    pmsApiProd,
    analytics,
  }: ZoneHost) {
    console.log('ZONETAIL INIT', analytics);
    const globalAnyType: any = global;
    globalAnyType.advertAgeApiDev = advertAgeApiDev;
    globalAnyType.pmsApiDev = pmsApiDev;
    globalAnyType.advertAgeApiProd = advertAgeApiProd;
    globalAnyType.pmsApiProd = pmsApiProd;
    globalAnyType.analytics = analytics;
    ZoneApi.init();
  },
};

export default ZontailConfig;
